/**
 * @generated SignedSource<<78a75024140ec219db79deac8bd338b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveBoletoDelinquencyWarning_charge$data = {
  readonly paymentMethods: ReadonlyArray<{
    readonly delinquency?: {
      readonly status: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "PaymentActiveBoletoDelinquencyWarning_charge";
};
export type PaymentActiveBoletoDelinquencyWarning_charge$key = {
  readonly " $data"?: PaymentActiveBoletoDelinquencyWarning_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveBoletoDelinquencyWarning_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveBoletoDelinquencyWarning_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "paymentMethods",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentMethodBoletoDelinquency",
              "kind": "LinkedField",
              "name": "delinquency",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PaymentMethodBoleto",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "4e0b5e16d65ef1260e0bf519cad6658b";

export default node;
